import { quoteListParams } from "./quote-list-params.const";

export const quoteListParamsDefaults = {
  [quoteListParams.createdOrSentBy]: null,
  [quoteListParams.assignedTo]: null,
  [quoteListParams.lastClientQuote]: null,
  [quoteListParams.createdAtFrom]: null,
  [quoteListParams.createdAtTo]: null,
};
